import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ConsultationModal from '../../components/feature/ConsultationModal';

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/c7a28c7c3c499ffca974a2d1a656fdb6.jpg',
      alt: '스마트 팩토리'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20small%20business%20office%20with%20happy%20smiling%20young%20Korean%20professionals%20laughing%20and%20collaborating%20together%20around%20a%20modern%20desk%2C%20joyful%20Korean%20team%20members%20with%20genuine%20smiles%20working%20on%20laptops%20and%20tablets%20in%20a%20cozy%20contemporary%20startup%20workspace%2C%20vibrant%20teal%20and%20emerald%20green%20color%20scheme%20with%20natural%20wood%20furniture%2C%20energetic%20positive%20entrepreneurial%20atmosphere%20with%20abundant%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20modern%20Korean%20office%20interior%20with%20indoor%20plants%20and%20minimalist%20design%2C%20optimistic%20friendly%20and%20welcoming%20Korean%20SME%20business%20environment%20showing%20diverse%20Korean%20men%20and%20women%20in%20casual%20business%20attire%20celebrating%20teamwork%20and%20success%2C%20ultra-wide%20panoramic%20view%20with%20bright%20clean%20aesthetic&width=1920&height=1080&seq=hero-korean-office-team-v3&orientation=landscape',
      alt: '협업하는 팀'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20Korean%20AI%20technology%20consultant%20in%20modern%20business%20suit%20and%20Korean%20factory%20plant%20manager%20wearing%20yellow%20safety%20hard%20hat%20and%20high-visibility%20vest%2C%20warm%20friendly%20partnership%20moment%20in%20industrial%20manufacturing%20facility%2C%20both%20Korean%20people%20smiling%20confidently%20showing%20trust%20and%20collaboration%2C%20bright%20teal%20and%20emerald%20green%20lighting%20creating%20optimistic%20atmosphere%2C%20modern%20factory%20background%20with%20advanced%20machinery%20and%20clean%20industrial%20environment%2C%20symbolizing%20successful%20AI%20implementation%20partnership%20and%20digital%20transformation%20in%20Korean%20manufacturing%2C%20wide%20angle%20shot%20capturing%20professional%20cooperation%20between%20Korean%20business%20professionals&width=1920&height=1080&seq=hero-korean-handshake-v2&orientation=landscape',
      alt: 'AI 전문가와 공장 관리자 악수'
    }
  ];

  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Image slideshow effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 8000); // Change image every 8 seconds

    return () => clearInterval(interval);
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="bg-white text-gray-900 overflow-hidden min-h-screen">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-gray-200/50 shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 md:h-20">
            <div className="flex items-center">
              <Link to="/" className="flex items-center cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/6baef3e451a11706c3b97de762a825a1/1bf7a1edbd9b5e181080d94b5de417df.png" 
                  alt="AI Logo" 
                  className="h-12 md:h-20 w-auto mr-2 md:mr-3"
                />
                <span className="text-lg sm:text-2xl md:text-4xl font-bold text-gray-900">중소기업AI지원센터</span>
              </Link>
            </div>
            
            <div className="hidden md:flex items-center space-x-3">
              <a href="#home" className="px-5 py-2.5 rounded-xl text-base text-gray-700 font-semibold cursor-pointer transition-all duration-300 hover:bg-gradient-to-r hover:from-teal-50 hover:to-emerald-50 hover:text-teal-600 hover:shadow-md">홈</a>
              <a href="#services" className="px-5 py-2.5 rounded-xl text-base text-gray-700 font-semibold cursor-pointer transition-all duration-300 hover:bg-gradient-to-r hover:from-teal-50 hover:to-emerald-50 hover:text-teal-600 hover:shadow-md">서비스</a>
              <div className="relative group">
                <button className="px-5 py-2.5 rounded-xl text-base text-gray-700 font-semibold flex items-center cursor-pointer transition-all duration-300 hover:bg-gradient-to-r hover:from-teal-50 hover:to-emerald-50 hover:text-teal-600 hover:shadow-md">
                  산업별 솔루션
                  <i className="ri-arrow-down-s-line ml-1 group-hover:rotate-180 transition-transform duration-200 w-4 h-4 flex items-center justify-center"></i>
                </button>
                <div className="absolute top-full left-0 bg-white shadow-xl rounded-xl py-3 mt-2 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <a href="#manufacturing" className="block px-5 py-3 text-base text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">제조업</a>
                  <a href="#logistics" className="block px-5 py-3 text-base text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">물류업</a>
                  <a href="#retail" className="block px-5 py-3 text-base text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">유통업</a>
                  <a href="#finance" className="block px-5 py-3 text-base text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">금융업</a>
                  <a href="#healthcare" className="block px-5 py-3 text-base text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">헬스케어</a>
                  <a href="#public" className="block px-5 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">공공기관</a>
                </div>
              </div>
              <a href="#success-cases" className="px-5 py-2.5 rounded-xl text-base text-gray-700 font-semibold cursor-pointer transition-all duration-300 hover:bg-gradient-to-r hover:from-teal-50 hover:to-emerald-50 hover:text-teal-600 hover:shadow-md">성공사례</a>
              <a href="#contact" className="px-5 py-2.5 rounded-xl text-base text-gray-700 font-semibold cursor-pointer transition-all duration-300 hover:bg-gradient-to-r hover:from-teal-50 hover:to-emerald-50 hover:text-teal-600 hover:shadow-md">문의하기</a>
            </div>
            
            <div className="flex items-center space-x-2 md:space-x-4">
              <a href="#contact" className="hidden sm:block">
                <button className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-4 md:px-8 py-2 md:py-4 rounded-xl font-semibold text-sm md:text-base hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
                  무료 상담
                </button>
              </a>
              <button 
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden text-gray-700 hover:text-teal-600 transition-colors w-8 h-8 flex items-center justify-center cursor-pointer"
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-4 py-4 space-y-2">
              <a href="#home" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">홈</a>
              <a href="#services" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">서비스</a>
              <a href="#manufacturing" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">제조업</a>
              <a href="#logistics" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">물류업</a>
              <a href="#retail" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">유통업</a>
              <a href="#finance" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">금융업</a>
              <a href="#healthcare" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">헬스케어</a>
              <a href="#public" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">공공기관</a>
              <a href="#success-cases" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">성공사례</a>
              <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-lg text-gray-700 font-semibold hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">문의하기</a>
              <button 
                onClick={() => {
                  setMobileMenuOpen(false);
                  setIsConsultationModalOpen(true);
                }}
                className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-4 py-3 rounded-lg font-semibold hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                무료 상담
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-16 md:pt-20 relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover animate-zoom"
              />
            </div>
          ))}
          <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/85 to-white/75"></div>
        </div>
        
        <div className="relative w-full z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-32">
            <div className="max-w-4xl">
              <div className="inline-block bg-teal-100 border border-teal-300 text-teal-700 px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold mb-6 md:mb-8">
                <i className="ri-award-line mr-2"></i>대한민국 대표 AI 컨설팅 전문기관
              </div>
              <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 md:mb-8 leading-tight md:leading-relaxed">
                AI(<span className="text-orange-500">무료 PoC</span>)로 <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">30일 안에</span><br />
                성과를 검증합니다.
              </h1>
              <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-8 md:mb-12 leading-relaxed font-light">
                현업 워크플로에 연결된 파일럿 → 표준화 → 확장.<br />
                <strong className="font-semibold text-gray-900">리스크는 낮추고, ROI는 앞당킵니다.</strong>
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6">
                <button 
                  onClick={() => setIsConsultationModalOpen(true)}
                  className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-6 md:px-10 py-4 md:py-5 rounded-xl text-base md:text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-search-line mr-2 md:mr-3"></i>무료 진단 예약
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About - Problem to Solution */}
      <section id="about" className="py-16 md:py-28 bg-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 right-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="text-center mb-12 md:mb-20">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              현재의 <span className="text-red-500">문제</span>에서<br />
              AI <span className="text-teal-600">솔루션</span>으로
            </h2>
            <p className="text-lg md:text-2xl text-gray-600">비즈니스 과제를 AI로 해결하는 체계적 접근</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-20 items-center">
            <div>
              <div className="flex items-center mb-6 md:mb-10">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-100 rounded-2xl flex items-center justify-center mr-4 md:mr-5 shadow-lg">
                  <i className="ri-error-warning-line text-red-600 text-2xl md:text-3xl"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900">현재 직면한 문제</h3>
              </div>
              <div className="space-y-4 md:space-y-6">
                <div className="flex items-start space-x-4 md:space-x-5 p-4 md:p-6 bg-white rounded-2xl border-l-4 border-red-300 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-database-line text-red-600 text-xl md:text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">산재한 데이터</h4>
                    <p className="text-sm md:text-base text-gray-600">부서별로 흩어진 데이터, 연결되지 않는 시스템</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4 md:space-x-5 p-4 md:p-6 bg-white rounded-2xl border-l-4 border-red-300 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-red-600 text-xl md:text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">느린 의사결정</h4>
                    <p className="text-sm md:text-base text-gray-600">보고서 작성과 검토에 소요되는 긴 시간</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4 md:space-x-5 p-4 md:p-6 bg-white rounded-2xl border-l-4 border-red-300 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-red-600 text-xl md:text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">사람 의존 공정</h4>
                    <p className="text-sm md:text-base text-gray-600">경험에만 의존하는 업무 프로세스</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="flex items-center mb-6 md:mb-10">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-teal-100 rounded-2xl flex items-center justify-center mr-4 md:mr-5 shadow-lg">
                  <i className="ri-lightbulb-line text-teal-600 text-2xl md:text-3xl"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900">AI 솔루션</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                <div className="p-4 md:p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl border border-teal-200 shadow-lg hover:shadow-xl transition-all hover:scale-105 duration-300">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                    <i className="ri-links-line text-teal-600 text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">데이터 연결</h4>
                  <p className="text-sm md:text-base text-gray-600">통합된 데이터 파이프라인 구축</p>
                </div>
                <div className="p-4 md:p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl border border-teal-200 shadow-lg hover:shadow-xl transition-all hover:scale-105 duration-300">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                    <i className="ri-robot-line text-teal-600 text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">자동화</h4>
                  <p className="text-sm md:text-base text-gray-600">반복 업무의 지능형 자동화</p>
                </div>
                <div className="p-4 md:p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl border border-teal-200 shadow-lg hover:shadow-xl transition-all hover:scale-105 duration-300">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                    <i className="ri-line-chart-line text-teal-600 text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">예측</h4>
                  <p className="text-sm md:text-base text-gray-600">데이터 기반 예측 및 최적화</p>
                </div>
                <div className="p-4 md:p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl border border-teal-200 shadow-lg hover:shadow-xl transition-all hover:scale-105 duration-300">
                  <div className="w-10 h-10 md:w-14 md:h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-3 md:mb-4">
                    <i className="ri-settings-line text-teal-600 text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">표준운영</h4>
                  <p className="text-sm md:text-base text-gray-600">일관된 프로세스 표준화</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center my-12 md:my-16">
            <div className="inline-flex items-center space-x-4 md:space-x-6">
              <div className="w-12 md:w-20 h-1.5 bg-gradient-to-r from-red-400 to-teal-400 rounded-full"></div>
              <div className="w-10 h-10 md:w-12 md:h-12 bg-teal-600 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-arrow-right-line text-white text-lg md:text-xl"></i>
              </div>
              <div className="w-12 md:w-20 h-1.5 bg-teal-400 rounded-full"></div>
            </div>
          </div>

          <div className="text-center">
            <button 
              onClick={() => setIsConsultationModalOpen(true)}
              className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-6 md:px-10 py-4 md:py-5 rounded-xl text-base md:text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line mr-2 md:mr-3"></i>우리 회사 문제 진단받기
            </button>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-teal-100">
            <div className="flex items-center justify-center mb-6 md:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-building-line text-white text-3xl md:text-4xl"></i>
              </div>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6 md:mb-8">
              중소기업을 위한 <span className="text-teal-600">AI 전문 파트너</span>
            </h3>
            <p className="text-base md:text-xl text-gray-700 leading-relaxed text-center mb-8 md:mb-10">
              중소기업AI센터는 국내에서 가장 AI 관련 구축 경험이 많은 업체 중 하나인 <strong className="text-teal-600 font-bold">(주)쿠스</strong>와 제휴하여 중소기업 대표님들께 가장 효율적이고 혁신적이며 저렴한 방법으로 AI를 활용할 수 있도록 도와드립니다.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="text-center">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-teal-100 rounded-xl flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-award-line text-teal-600 text-2xl md:text-3xl"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">풍부한 경험</h4>
                <p className="text-sm md:text-base text-gray-600">국내 최고 수준의<br />AI 구축 노하우</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-rocket-line text-emerald-600 text-2xl md:text-3xl"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">혁신적 솔루션</h4>
                <p className="text-sm md:text-base text-gray-600">최신 AI 기술을<br />실무에 적용</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-cyan-100 rounded-xl flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-price-tag-3-line text-cyan-600 text-2xl md:text-3xl"></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-2">합리적 비용</h4>
                <p className="text-sm md:text-base text-gray-600">중소기업 맞춤형<br />가격 정책</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="py-16 md:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 md:mb-20">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">서비스 한눈에</h2>
            <p className="text-lg md:text-2xl text-gray-600">전략부터 실행까지, 완전한 AI 전환 서비스</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
            {[
              {
                icon: 'ri-strategy-line',
                gradient: 'from-teal-500 to-cyan-500',
                title: 'AI 전략/로드맵',
                desc: '비즈니스 과제 정의, 우선순위·ROI 설계',
                features: ['AI 성숙도 진단', 'ROI 기반 우선순위 설정', '단계별 실행 로드맵', '리스크 관리 계획']
              },
              {
                icon: 'ri-tools-line',
                gradient: 'from-emerald-500 to-green-500',
                title: '운영 혁신·자동화',
                desc: '수요예측, 재고·생산·품질, 세일즈/CS 자동화',
                features: ['프로세스 최적화', '예측 모델 구축', '자동화 시스템 도입', '품질 관리 고도화']
              },
              {
                icon: 'ri-database-2-line',
                gradient: 'from-cyan-500 to-teal-500',
                title: '데이터·모델링',
                desc: '데이터 파이프라인, LLM/ML, 대시보드',
                features: ['데이터 통합 및 정제', 'ML/DL 모델 개발', 'LLM 커스터마이징', '실시간 대시보드']
              },
              {
                icon: 'ri-graduation-cap-line',
                gradient: 'from-amber-500 to-orange-500',
                title: '교육·변화관리',
                desc: '경영진 워크숍, 현업 실습, 거버넌스',
                features: ['경영진 AI 리더십', '현업 실무 교육', 'AI 윤리 및 거버넌스', '조직 변화 관리']
              }
            ].map((service, idx) => (
              <div key={idx} className="group bg-white rounded-3xl p-6 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:scale-105">
                <div className={`w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br ${service.gradient} rounded-2xl flex items-center justify-center mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                  <i className={`${service.icon} text-white text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">{service.title}</h3>
                <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8 leading-relaxed">{service.desc}</p>
                <div className="space-y-3 md:space-y-4">
                  {service.features.map((feature, i) => (
                    <div key={i} className="flex items-center space-x-3 md:space-x-4">
                      <div className={`w-5 h-5 md:w-6 md:h-6 bg-gradient-to-br ${service.gradient} rounded-full flex items-center justify-center flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs md:text-sm"></i>
                      </div>
                      <span className="text-sm md:text-base text-gray-700 font-medium">{feature}</span>
                    </div>
                  ))}
                </div>
                <button className={`mt-6 md:mt-8 w-full py-3 md:py-4 bg-gradient-to-r ${service.gradient} text-white font-bold text-sm md:text-base rounded-xl hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap`}>
                  자세히 보기
                </button>
              </div>
            ))}
          </div>

          <div className="text-center mt-12 md:mt-20">
            <div className="bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50 rounded-3xl p-6 md:p-12 shadow-xl">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-5">맞춤형 컨설팅이 필요하신가요?</h3>
              <p className="text-base md:text-xl text-gray-600 mb-6 md:mb-8">귀하의 비즈니스에 최적화된 AI 솔루션을 제안드립니다</p>
              <button 
                onClick={() => setIsConsultationModalOpen(true)}
                className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-6 md:px-10 py-4 md:py-5 rounded-xl text-base md:text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-customer-service-2-line mr-2 md:mr-3"></i>전문가 상담 예약
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Solutions - Manufacturing */}
      <section id="manufacturing" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">제조업</div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">스마트 팩토리 구축</h2>
            <p className="text-xl text-gray-600">AI 기반 생산 최적화로 품질과 효율성을 동시에 향상</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Premium%20modern%20smart%20factory%20interior%20with%20advanced%20AI-powered%20robotic%20manufacturing%20systems%2C%20sleek%20automated%20production%20lines%20with%20precision%20robotic%20arms%2C%20sophisticated%20digital%20control%20panels%20displaying%20real-time%20analytics%2C%20pristine%20industrial%20environment%20with%20professional%20teal%20and%20white%20LED%20lighting%2C%20cutting-edge%20manufacturing%20technology%2C%20ultra-high%20quality%20industrial%20photography&width=800&height=600&seq=manufacturing-premium-v2&orientation=landscape"
                alt="스마트 팩토리"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="space-y-8">
              <div className="flex items-start space-x-6 p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <i className="ri-eye-line text-teal-600 text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">AI 비전 검사</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">딥러닝 기반 불량 검출로 품질 관리 자동화 및 불량률 최소화</p>
                </div>
              </div>
              <div className="flex items-start space-x-6 p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <i className="ri-settings-3-line text-teal-600 text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">예지 정비</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">설비 고장 예측으로 다운타임 최소화 및 유지보수 비용 절감</p>
                </div>
              </div>
              <div className="flex items-start space-x-6 p-6 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md">
                  <i className="ri-line-chart-line text-teal-600 text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">생산 최적화</h3>
                  <p className="text-lg text-gray-600 leading-relaxed">실시간 데이터 분석으로 생산 계획 최적화 및 효율성 극대화</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Solutions - Logistics */}
      <section id="logistics" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-green-100 text-green-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">물류업</div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">지능형 물류 시스템</h2>
            <p className="text-xl text-gray-600">AI로 배송 경로를 최적화하고 물류 비용을 절감</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-route-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">경로 최적화</h3>
                  <p className="text-gray-600">AI 알고리즘으로 최적 배송 경로 자동 계산 및 연료비 절감</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-stack-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">재고 관리</h3>
                  <p className="text-gray-600">수요 예측 기반 최적 재고 수준 유지 및 보관 비용 최소화</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">실시간 추적</h3>
                  <p className="text-gray-600">IoT 센서와 AI로 화물 위치 실시간 모니터링 및 배송 예측</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20logistics%20warehouse%20with%20AI-powered%20automated%20systems%2C%20robotic%20vehicles%20moving%20packages%2C%20digital%20tracking%20displays%2C%20organized%20storage%20racks%2C%20clean%20industrial%20environment%20with%20green%20and%20white%20lighting%2C%20smart%20logistics%20technology&width=600&height=400&seq=logistics-main&orientation=landscape"
                alt="지능형 물류"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Industry Solutions - Retail */}
      <section id="retail" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-purple-100 text-purple-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">유통업</div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">스마트 리테일 솔루션</h2>
            <p className="text-xl text-gray-600">고객 행동 분석과 수요 예측으로 매출 극대화</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20retail%20store%20with%20AI-powered%20customer%20analytics%2C%20digital%20displays%20showing%20personalized%20recommendations%2C%20smart%20shelves%20with%20sensors%2C%20clean%20shopping%20environment%20with%20purple%20and%20white%20lighting%2C%20advanced%20retail%20technology&width=600&height=400&seq=retail-main&orientation=landscape"
                alt="스마트 리테일"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">고객 분석</h3>
                  <p className="text-gray-600">AI 기반 고객 행동 분석으로 맞춤형 상품 추천 및 마케팅 최적화</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-bar-chart-box-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">수요 예측</h3>
                  <p className="text-gray-600">AI 기반 수요 예측으로 재고 관리와 발주를 자동화했습니다.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">동적 가격 책정</h3>
                  <p className="text-gray-600">AI 기반 실시간 가격 최적화로 수익성과 경쟁력을 동시에 확보했습니다.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Solutions - Finance */}
      <section id="finance" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-amber-100 text-amber-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">금융업</div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">AI 금융 솔루션</h2>
            <p className="text-xl text-gray-600">리스크 관리와 사기 탐지로 안전한 금융 서비스 제공</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">사기 탐지</h3>
                  <p className="text-gray-600">실시간 이상 거래 탐지 및 금융 사기 예방으로 고객 자산 보호</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-pie-chart-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">신용 평가</h3>
                  <p className="text-gray-600">AI 기반 정교한 신용 평가 모델로 대출 심사의 정확성과 속도를 개선했습니다.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-robot-2-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">로보어드바이저</h3>
                  <p className="text-gray-600">개인 맞춤형 자산 관리 및 투자 포트폴리오 자동 최적화</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20financial%20technology%20office%20with%20AI-powered%20analytics%20systems%2C%20digital%20displays%20showing%20financial%20data%20and%20charts%2C%20secure%20banking%20environment%20with%20gold%20and%20white%20theme%2C%20professional%20fintech%20workspace%20with%20advanced%20security%20technology&width=600&height=400&seq=finance-main&orientation=landscape"
                alt="AI 금융"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Industry Solutions - Healthcare */}
      <section id="healthcare" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">헬스케어</div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">AI 헬스케어 시스템</h2>
            <p className="text-xl text-gray-600">의료 진단 보조와 환자 관리로 의료 서비스 품질 향상</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20healthcare%20facility%20with%20AI-powered%20medical%20diagnostic%20systems%2C%20digital%20displays%20showing%20patient%20data%20and%20medical%20imaging%2C%20clean%20hospital%20environment%20with%20teal%20and%20white%20lighting%2C%20advanced%20medical%20technology%20and%20monitoring%20equipment&width=600&height=400&seq=healthcare-main&orientation=landscape"
                alt="AI 헬스케어"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-stethoscope-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">진단 보조</h3>
                  <p className="text-gray-600">의료 영상 분석 AI로 질병 조기 발견 및 진단 정확도 향상</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">환자 모니터링</h3>
                  <p className="text-gray-600">실시간 환자 상태 모니터링 및 이상 징후 조기 경보</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-capsule-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">맞춤형 치료</h3>
                  <p className="text-gray-600">환자 데이터 분석으로 개인화된 치료 계획 수립 지원</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Solutions - Public */}
      <section id="public" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">공공기관</div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">스마트 공공 서비스</h2>
            <p className="text-xl text-gray-600">AI로 행정 효율성을 높이고 시민 만족도 향상</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-government-line text-indigo-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">행정 자동화</h3>
                  <p className="text-gray-600">AI 기반 문서 처리 자동화로 행정 업무 효율성 극대화</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-traffic-light-line text-indigo-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">스마트 시티</h3>
                  <p className="text-gray-600">교통 흐름 최적화 및 에너지 관리로 도시 운영 효율 향상</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-star-line text-indigo-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">공공 안전</h3>
                  <p className="text-gray-600">AI 기반 위험 예측 및 긴급 상황 대응 시스템 구축</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20smart%20city%20control%20center%20with%20AI-powered%20public%20service%20systems%2C%20digital%20displays%20showing%20city%20infrastructure%20data%2C%20clean%20government%20office%20environment%20with%20indigo%20and%20white%20lighting%2C%20advanced%20public%20administration%20technology&width=600&height=400&seq=public-main&orientation=landscape"
                alt="스마트 공공 서비스"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 성공 사례 섹션 */}
      <section id="success-cases" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">성공 사례</h2>
            <p className="text-xl text-gray-600">다양한 산업 분야에서 검증된 AI 솔루션 성과</p>
          </div>

          {/* 제조업 성공사례 */}
          <div className="mb-20">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <i className="ri-settings-3-line text-teal-500 mr-3"></i>
              제조업
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-cpu-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">A전자 스마트 팩토리 구축</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 비전 검사 시스템과 예지 정비 솔루션을 도입하여 생산 라인의 효율성을 극대화했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">불량률 <strong className="text-2xl font-bold text-teal-700">87% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">생산성 <strong className="text-2xl font-bold text-teal-700">43% 향상</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">설비 가동률 <strong className="text-2xl font-bold text-teal-700">95% 달성</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-robot-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">B자동차 부품 품질관리 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">딥러닝 기반 실시간 품질 검사로 자동차 부품의 미세 결함까지 정확하게 탐지합니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">검사 시간 <strong className="text-2xl font-bold text-teal-700">92% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">검사 정확도 <strong className="text-2xl font-bold text-teal-700">99.8% 달성</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">인건비 <strong className="text-2xl font-bold text-teal-700">65% 절감</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-line-chart-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">C화학 생산 최적화 솔루션</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 기반 공정 최적화로 화학 제품 생산의 수율과 품질을 동시에 개선했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">생산 수율 <strong className="text-2xl font-bold text-teal-700">38% 증가</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">에너지 비용 <strong className="text-2xl font-bold text-teal-700">28% 절감</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">품질 편차 <strong className="text-2xl font-bold text-teal-700">75% 감소</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 물류업 성공사례 */}
          <div className="mb-20">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <i className="ri-truck-line text-teal-500 mr-3"></i>
              물류업
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-route-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">D물류 배송 경로 최적화</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 기반 실시간 경로 최적화로 배송 효율을 극대화하고 비용을 절감했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">배송 시간 <strong className="text-2xl font-bold text-teal-700">35% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">연료 비용 <strong className="text-2xl font-bold text-teal-700">42% 절감</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">고객 문의 <strong className="text-2xl font-bold text-teal-700">67% 감소</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-stack-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">E유통 스마트 창고 관리</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 재고 관리 시스템으로 창고 운영의 효율성과 정확성을 대폭 개선했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">재고 정확도 <strong className="text-2xl font-bold text-teal-700">99.5% 달성</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">입출고 시간 <strong className="text-2xl font-bold text-teal-700">58% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">공간 활용률 <strong className="text-2xl font-bold text-teal-700">47% 증가</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-map-pin-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">F택배 실시간 추적 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">IoT와 AI를 결합한 실시간 화물 추적으로 배송 투명성을 확보했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">배송 가시성 <strong className="text-2xl font-bold text-teal-700">100% 확보</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">분실률 <strong className="text-2xl font-bold text-teal-700">94% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">고객 문의 <strong className="text-2xl font-bold text-teal-700">67% 감소</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 유통업 성공사례 */}
          <div className="mb-20">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <i className="ri-store-2-line text-teal-500 mr-3"></i>
              유통업
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-user-heart-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">G백화점 고객 분석 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 기반 고객 행동 분석으로 맞춤형 마케팅과 매장 운영을 최적화했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">매출 <strong className="text-2xl font-bold text-teal-700">52% 증가</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">재방문율 <strong className="text-2xl font-bold text-teal-700">73% 향상</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">마케팅 ROI <strong className="text-2xl font-bold text-teal-700">3.8배 증가</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shopping-cart-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">H마트 수요 예측 솔루션</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">머신러닝 기반 수요 예측으로 재고 관리와 발주를 자동화했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">재고 회전율 <strong className="text-2xl font-bold text-teal-700">68% 개선</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">폐기 손실 <strong className="text-2xl font-bold text-teal-700">81% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">품절률 <strong className="text-2xl font-bold text-teal-700">92% 감소</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-price-tag-3-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">I온라인몰 동적 가격 책정</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 기반 실시간 가격 최적화로 수익성과 경쟁력을 동시에 확보했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">매출 <strong className="text-2xl font-bold text-teal-700">45% 증가</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">이익률 <strong className="text-2xl font-bold text-teal-700">37% 향상</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">시장 점유율 <strong className="text-2xl font-bold text-teal-700">2.3배 증가</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 금융업 성공사례 */}
          <div className="mb-20">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <i className="ri-bank-line text-teal-500 mr-3"></i>
              금융업
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">J은행 이상거래 탐지 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">딥러닝 기반 실시간 사기 탐지로 금융 보안을 강화하고 손실을 예방했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">사기 탐지율 <strong className="text-2xl font-bold text-teal-700">96% 달성</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">오탐률 <strong className="text-2xl font-bold text-teal-700">78% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">금융 손실 <strong className="text-2xl font-bold text-teal-700">89% 방지</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-file-list-3-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">K캐피탈 AI 신용 평가</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">머신러닝 기반 신용 평가 모델로 대출 심사의 정확성과 속도를 개선했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">심사 시간 <strong className="text-2xl font-bold text-teal-700">85% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">연체율 <strong className="text-2xl font-bold text-teal-700">62% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">승인율 <strong className="text-2xl font-bold text-teal-700">34% 향상</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-line-chart-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">L증권 로보어드바이저</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 기반 자산 관리 서비스로 고객 맞춤형 투자 포트폴리오를 제공합니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">운용 자산 <strong className="text-2xl font-bold text-teal-700">4.2배 증가</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">평균 수익률 <strong className="text-2xl font-bold text-teal-700">18.5% 달성</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">고객 만족도 <strong className="text-2xl font-bold text-teal-700">92% 달성</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 헬스케어 성공사례 */}
          <div className="mb-20">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <i className="ri-heart-pulse-line text-teal-500 mr-3"></i>
              헬스케어
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-stethoscope-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">M병원 AI 진단 보조 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">의료 영상 분석 AI로 질병 조기 발견 및 진단 정확도 향상</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">진단 정확도 <strong className="text-2xl font-bold text-teal-700">97.8% 달성</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">판독 시간 <strong className="text-2xl font-bold text-teal-700">73% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">조기 발견율 <strong className="text-2xl font-bold text-teal-700">56% 향상</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-heart-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">N요양원 환자 모니터링</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">IoT와 AI를 활용한 24시간 환자 상태 모니터링으로 안전을 확보했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">응급 대응 시간 <strong className="text-2xl font-bold text-teal-700">68% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">낙상 사고 <strong className="text-2xl font-bold text-teal-700">84% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">간호 효율성 <strong className="text-2xl font-bold text-teal-700">47% 향상</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-capsule-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">O제약 맞춤형 치료 솔루션</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">유전자 분석과 AI를 결합하여 환자별 최적의 치료법을 제시합니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">치료 효과 <strong className="text-2xl font-bold text-teal-700">63% 향상</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">부작용 <strong className="text-2xl font-bold text-teal-700">71% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">치료 기간 <strong className="text-2xl font-bold text-teal-700">42% 단축</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 공공기관 성공사례 */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center">
              <i className="ri-government-line text-teal-500 mr-3"></i>
              공공기관
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-file-text-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">P시청 행정 자동화 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 기반 문서 처리 자동화로 행정 업무의 효율성을 대폭 개선했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">처리 시간 <strong className="text-2xl font-bold text-teal-700">76% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">민원 만족도 <strong className="text-2xl font-bold text-teal-700">88% 달성</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">인건비 <strong className="text-2xl font-bold text-teal-700">52% 절감</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-building-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">Q구청 스마트 시티 플랫폼</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">IoT와 AI를 활용한 도시 인프라 통합 관리로 시민 편의를 향상시켰습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">에너지 효율 <strong className="text-2xl font-bold text-teal-700">41% 향상</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">교통 혼잡 <strong className="text-2xl font-bold text-teal-700">38% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">시민 만족도 <strong className="text-2xl font-bold text-teal-700">79% 향상</strong></span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shield-line text-3xl text-teal-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">R경찰청 공공 안전 시스템</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">AI 영상 분석과 예측 모델로 범죄 예방과 신속한 대응을 실현했습니다.</p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">범죄율 <strong className="text-2xl font-bold text-teal-700">45% 감소</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">출동 시간 <strong className="text-2xl font-bold text-teal-700">58% 단축</strong></span>
                  </div>
                  <div className="flex items-center text-sm">
                    <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                    <span className="text-gray-700">검거율 <strong className="text-2xl font-bold text-teal-700">67% 향상</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-12 md:py-20 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
            <i className="ri-customer-service-2-line text-white text-xl md:text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">더 궁금한 점이 있으신가요?</h2>
          <p className="text-blue-100 mb-6 md:mb-8 text-base md:text-lg">AI 전문가와 직접 상담하고 맞춤형 솔루션을 확인하세요</p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <button 
              onClick={() => setIsConsultationModalOpen(true)}
              className="bg-white text-blue-600 px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-bold hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>즉시 상담 예약
            </button>
            <button 
              onClick={() => setIsConsultationModalOpen(true)}
              className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-bold hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-text-line mr-2"></i>RFP 제출하기
            </button>
          </div>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-8 text-blue-100 text-sm md:text-base">
            <div className="flex items-center space-x-2">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              <span>070-4352-1550</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              <span>gajwari@ace-biz.kr</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8 md:mb-12">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-2 md:space-x-3 mb-4 md:mb-6">
                <img 
                  src="https://static.readdy.ai/image/6baef3e451a11706c3b97de762a825a1/1bf7a1edbd9b5e181080d94b5de417df.png" 
                  alt="AI Logo" 
                  className="h-12 md:h-20 w-auto mr-2 md:mr-3"
                />
                <span className="text-xl md:text-4xl font-bold text-white">중소기업AI지원센터</span>
              </div>
              <p className="text-gray-400 mb-4 md:mb-6 max-w-md leading-relaxed text-sm md:text-base">
                중소기업AI지원센터는 한화생명금융서비스 에이스사업부내 설치된 조직으로 중소기업 대표님들의 AI구축을 도와드리고 있습니다
              </p>
              <div className="space-y-2 md:space-y-3 text-sm md:text-base">
                <div className="flex items-center">
                  <i className="ri-user-line w-5 h-5 flex items-center justify-center"></i>
                  <span>대표: 박미경</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
                  <span>서울 강서구 양천로 357 려산빌딩 5층</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                  <span>070-4352-1550</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                  <span>gajwari@ace-biz.kr</span>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="text-white font-semibold mb-4 md:mb-6 text-base md:text-lg">서비스</h4>
              <ul className="space-y-2 md:space-y-3 text-sm md:text-base">
                <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">AI 전략/로드맵</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">운영 혁신·자동화</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">데이터·모델링</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">교육·변화관리</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-white font-semibold mb-4 md:mb-6 text-base md:text-lg">산업별 솔루션</h4>
              <ul className="space-y-2 md:space-y-3 text-sm md:text-base">
                <li><a href="#manufacturing" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">제조업</a></li>
                <li><a href="#logistics" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">물류</a></li>
                <li><a href="#retail" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">리테일</a></li>
                <li><a href="#finance" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">금융</a></li>
                <li><a href="#healthcare" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">헬스케어</a></li>
                <li><a href="#public" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">공공기관</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center text-sm md:text-base">
            <p className="text-gray-400 mb-4 md:mb-0">© 2024 중소기업 AI 지원센터. All rights reserved.</p>
            <div className="flex space-x-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      <ConsultationModal 
        isOpen={isConsultationModalOpen} 
        onClose={() => setIsConsultationModalOpen(false)} 
      />
    </div>
  );
}
